<kendo-grid #grid #cartGrid [data]="cartview"
            [pageable]="{ buttonCount: 5, info: true, responsive:true, pageSizes:[50,75,100] }"
            class="checkOutReviewGridCls"
            [pageSize]="gridState.take"
            [skip]="gridState.skip"
            [sortable]="false"
            [navigable]="true"
            [resizable]="false"
            [groupable]="false"
            [selectable]="false"
            (pageChange)="reviewPageChange($event)">

  <kendo-grid-column media="(max-width: 1024px)" title="Items">
    <ng-template kendoGridCellTemplate let-dataItem>
      <div class="row" style="margin-bottom:10px;">
        <div class="col-12 title-bold">
          {{dataItem.itemNumber}}-{{dataItem.itemDescription}}
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12 col-md-4 paddingZero">
          <span class="txt-bold">{{cartReviewTxt.finishLbl?cartReviewTxt.finishLbl:cartReview.finishLbl}}:</span>
          {{dataItem.finish}}
        </div>
        <div class="col-sm-12 col-md-4 paddingZero" *ngIf="dataItem.paintName">
          <span class="txt-bold">{{cartReviewTxt.paintLbl?cartReviewTxt.paintLbl:cartReview.paintLbl}}:</span>
          {{dataItem.paintName}}
        </div>
        <div class="col-sm-12 col-md-4 paddingZero">
          <span class="txt-bold">{{cartReviewTxt.extrusionLbl?cartReviewTxt.extrusionLbl:cartReview.extrusionLbl}}:</span>
          {{dataItem.size}}
        </div>
      </div>

      <div class="row">
        <div class="col-6 col-md-4 paddingZero">
          <span class="txt-bold">{{cartReviewTxt.quantityLbl?cartReviewTxt.quantityLbl:cartReview.quantityLbl}}:</span>
          {{dataItem.quantity}}
        </div>

        <div class="col-6 col-md-4 paddingZero">
          <span class="txt-bold">{{cartReviewTxt.unitLbl?cartReviewTxt.unitLbl:cartReview.unitLbl}}:</span>
          EA
        </div>
      </div>

      <div class="row" *ngIf="dataItem.quoteName">
        <div class="col-2 paddingZero txt-bold">
          Quote Name:
        </div>
        <div class="col-10">
          {{dataItem.quoteName}}
        </div>
      </div>

      <div class="row">
        <div class="col-12 paddingZero" id="extendedPrice">
          <kendo-expansionpanel>
            <ng-template kendoExpansionPanelTitleDirective>
              <div class="header-content">
                <span>Price: {{dataItem.extendedPrice | currency: dataItem.currencySymbol}}</span>
              </div>
            </ng-template>
            <div style="font-size:10px;">
              {{cartReviewTxt.listPriceLbl?cartReviewTxt.listPriceLbl:cartReview.listPriceLbl}} -
              {{dataItem.listPrice | currency: dataItem.currencySymbol}}
            </div>
            <div style="font-size:10px;">
              {{cartReviewTxt.unitPriceLbl?cartReviewTxt.unitPriceLbl:cartReview.unitPriceLbl}} -
              {{dataItem.unitPrice | currency: dataItem.currencySymbol}}
            </div>
            <div style="font-size:10px;">
              {{cartReviewTxt.multiplierLbl?cartReviewTxt.multiplierLbl:cartReview.multiplierLbl}} -
              {{dataItem.cmp | number:'1.3-3'}}
            </div>
          </kendo-expansionpanel>
        </div>
      </div>
    </ng-template>
    <ng-template kendoGridFooterTemplate>
      <div class="row">
        <div class="col-5 totalPrice">
          {{cartReviewTxt.totalPriceLbl?cartReviewTxt.totalPriceLbl:cartReview.totalPriceLbl}}
        </div>
        <div class="col-3"></div>
        <div class="col-4 totalPrice">{{cartItemsTotal | currency}}</div>
      </div>

      <div class="row" *ngIf="totalPromoCredit > 0">
        <div class="col-12" style="text-align:right;">
          <div class="review-minfee-line-sm promo-credit-container">

            <span class="promo-remove-btn"
                  (click)="removePromoCodes()">
              ✕
            </span>

           <!-- <span class="promo-help-icon"
                  title="Please select 'X' to remove Credit">
              ?
            </span>-->

            <span class="promo-credit-text">
              Promo: - {{ totalPromoCredit | currency }}
            </span>

          </div>
        </div>
      </div>
      
      <div class="row mt-2">
        <div class="col-12 text-right">

        

          <div style="margin-top:10px; text-align:right;">

            <div style="display:flex; justify-content:flex-end; align-items:center;">

              <span style="margin-right:4px;">Promo Code:</span>

              <input type="text"
                     class="form-control"
                     placeholder="Enter Promo Code"
                     [(ngModel)]="promoCode"
                     style="max-width:140px;">

              <button type="button"
                      class="btn btn-secondary"
                      style="margin-left:6px;padding:4px 10px;height:32px;line-height:1;"
                      [disabled]="!promoCode || !promoCode.trim()"
                      (click)="applyPromoCode()">
                Apply
              </button>

            </div>

            <div *ngIf="promoMessage"
                 [style.color]="promoMessageColor"
                 style="
         font-size:12px;
         font-weight:600;
         margin-top:4px;
         text-align:right;
         padding-right:64px;
         white-space:nowrap;">
              {{ promoMessage }}
            </div>

          </div>

        </div>
      </div>
      <div class="post-indicator-text-sm">
        <div>
          <div>
            {{cartReviewTxt.gridTextLbl1?cartReviewTxt.gridTextLbl1:cartReview.gridTextLbl1}}
          </div>
          <div>
            {{cartReviewTxt.gridTextLbl4?cartReviewTxt.gridTextLbl4:cartReview.gridTextLbl4}}
          </div>
          <div>
            {{cartReviewTxt.gridTextLbl5?cartReviewTxt.gridTextLbl5:cartReview.gridTextLbl5}}
          </div>
          <div>
            {{cartReviewTxt.gridTextLbl3?cartReviewTxt.gridTextLbl3:cartReview.gridTextLbl3}}
          </div>
        </div>
      </div>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column media="(min-width: 1050px)" title="{{cartReviewTxt.lineLbl?cartReviewTxt.lineLbl:cartReview.lineLbl}}"
                     [width]="60" [resizable]="false" [sortable]="true" [groupable]="false"
                     [editable]="false" [footerStyle]="{'border-color': 'rgba(0,0,0,0)'}">
    <ng-template kendoGridCellTemplate class="d-flex justify-content-center" let-rowIndex="rowIndex">
      <strong>{{rowIndex + 1}}</strong>
    </ng-template>
    <ng-template kendoGridFooterTemplate>
      <div class="post-indicator-text">
        <div>
          <div>
            {{cartReviewTxt.gridTextLbl1?cartReviewTxt.gridTextLbl1:cartReview.gridTextLbl1}}
          </div>
          <div>
            {{cartReviewTxt.gridTextLbl4?cartReviewTxt.gridTextLbl4:cartReview.gridTextLbl4}}
          </div>
          <div>
            {{cartReviewTxt.gridTextLbl5?cartReviewTxt.gridTextLbl5:cartReview.gridTextLbl5}}
          </div>
          <div>
            {{cartReviewTxt.gridTextLbl3?cartReviewTxt.gridTextLbl3:cartReview.gridTextLbl3}}
          </div>
        </div>
      </div>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column media="(min-width: 1050px)" [filterable]="false" [sortable]="false" field="quantity"
                     title="{{cartReviewTxt.quantityLbl?cartReviewTxt.quantityLbl:cartReview.quantityLbl}}"
                     [width]="80" [minResizableWidth]="20">
    <ng-template kendoGridCellTemplate let-dataItem>
      {{dataItem.quantity}}
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column media="(min-width: 1050px)" [editable]="false" field="unitOfMeasure"
                     [minResizableWidth]="20" [width]="70" title="{{cartReviewTxt.unitLbl?cartReviewTxt.unitLbl:cartReview.unitLbl}}"
                     [footerStyle]="{'border-color': 'rgba(0,0,0,0)'}">
    <ng-template kendoGridCellTemplate let-dataItem>
      EA
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column media="(min-width: 1050px)" [editable]="false" field="itemNumber"
                     [minResizableWidth]="70" [width]="120" title="{{cartReviewTxt.itemLbl?cartReviewTxt.itemLbl:cartReview.itemLbl}}"
                     [footerStyle]="{'border-color': 'rgba(0,0,0,0)'}">
    <ng-template kendoGridCellTemplate let-dataItem>
      {{dataItem.itemNumber}}
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column media="(min-width: 1050px)" field="availableFinish"
                     title="{{cartReviewTxt.finishLbl?cartReviewTxt.finishLbl:cartReview.finishLbl}}"
                     [width]="140" [filterable]="false" [sortable]="false">
    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
      {{dataItem.finish}}
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column media="(min-width: 1050px)" field="paint"
                     title="{{cartReviewTxt.paintLbl?cartReviewTxt.paintLbl:cartReview.paintLbl}}"
                     [width]="140" [filterable]="false" [sortable]="false">
    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
      {{dataItem.paintName}}
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column media="(min-width: 1050px)" field="availableFinishes"
                     title="{{cartReviewTxt.extrusionLbl?cartReviewTxt.extrusionLbl:cartReview.extrusionLbl}}"
                     [editable]="false" [width]="100" [filterable]="false" [sortable]="false">
    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
      {{dataItem.size}}
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column media="(min-width: 1050px)" [editable]="false" field="itemDescription" [minResizableWidth]="180" [width]="180"
                     title="{{cartReviewTxt.descriptionLbl?cartReviewTxt.descriptionLbl:cartReview.descriptionLbl}}"
                     [footerStyle]="{'border-color': 'rgba(0,0,0,0)'}">
  </kendo-grid-column>

  <kendo-grid-column media="(min-width: 1050px)" [editable]="false" field="basePrice"
                     [minResizableWidth]="70" [width]="100"
                     title="{{cartReviewTxt.listPriceLbl?cartReviewTxt.listPriceLbl:cartReview.listPriceLbl}}"
                     [footerStyle]="{'border-color': 'rgba(0,0,0,0)'}">
    <ng-template kendoGridCellTemplate let-dataItem>
      {{dataItem.listPrice | currency: dataItem.currencySymbol}}
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column media="(min-width: 1050px)" [editable]="false" field="cmp" [minResizableWidth]="70" [width]="70"
                     title="{{cartReviewTxt.multiplierLbl?cartReviewTxt.multiplierLbl:cartReview.multiplierLbl}}"
                     [footerStyle]="{'border-color': 'rgba(0,0,0,0)'}">
    <ng-template kendoGridCellTemplate let-dataItem>
      <span>
        {{dataItem.cmp | number:'1.3-3'}}
      </span>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column media="(min-width: 1050px)" [editable]="false" field="unitPrice" [minResizableWidth]="70" [width]="80"
                     title="{{cartReviewTxt.unitPriceLbl?cartReviewTxt.unitPriceLbl:cartReview.unitPriceLbl}}"
                     [footerStyle]="{'border-color': 'rgba(0,0,0,0)'}">
    <ng-template kendoGridCellTemplate let-dataItem>
      {{dataItem.unitPrice | currency: dataItem.currencySymbol}}
    </ng-template>

    <ng-template kendoGridFooterTemplate>
      <div *ngIf="!freightEstimateFlag">
        <h4 class="cartTotalInGrid">
          {{cartItemsTotal | currency}} -
          {{cartReviewTxt.totalPriceLbl?cartReviewTxt.totalPriceLbl:cartReview.totalPriceLbl}}
        </h4>
      </div>

    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column media="(min-width: 1050px)" [editable]="false" field="extendedPrice" [minResizableWidth]="70" [width]="100"
                     title="{{cartReviewTxt.extendedPriceLbl?cartReviewTxt.extendedPriceLbl:cartReview.extendedPriceLbl}}">
    <ng-template kendoGridCellTemplate let-dataItem>
      {{dataItem.extendedPrice | currency: dataItem.currencySymbol}}
    </ng-template>
    <ng-template kendoGridFooterTemplate>
      <div class="cart-review-footer-price-with-freight" *ngIf="freightEstimateFlag">
        <div class="footer-row">
          <span class="footer-label">Item Total:</span>
          <span class="footer-value">{{cartItemsTotal | currency}}</span>
        </div>

        <div class="footer-row">
          <span class="footer-label redText">{{ minFeeDisplayLine }} </span>
        </div>
        <div class="footer-row" *ngIf="totalPromoCredit <0 ||  promofreefreight =='P' || promofreefreight =='CPT' ">

          <span class="promo-remove-btn"
                (click)="removePromoCodes()">
            ✕
          </span>

          <!--<span class="promo-help-icon"
                title="Please select 'X' to remove Credit">
            ?
          </span>-->

          <span class="footer-label promo-credit-text">
            Promo:
          </span>

          <span class="footer-value promo-credit-text">
             {{ totalPromoCredit | currency }}
          </span>

        </div>
        <div class="footer-row">
          <span class="footer-label">Shipping: </span>
          <span class="footer-value">
            {{checkoutService.prepaidFreightSelected ? (displayShippingAmount | currency) : "TBD"}}
          </span>
        </div>

        <div class="footer-row">
          <span class="footer-label">Order Total: </span>
          <span class="footer-value">
            {{checkoutService.prepaidFreightSelected ? (cartItemsTotal + displayShippingAmount + topMinOrderFeeValue + totalPromoCredit | currency) : "TBD"}}
          </span>
        </div>
        <div class="footer-row mt-2 promo-row">

          <span class="footer-label promo-label">Promo Code:</span>

          <input type="text"
                 class="form-control promo-input"
                 placeholder="Enter Promo Code"
                 [(ngModel)]="promoCode">

          <button type="button"
                  class="btn btn-secondary promo-btn"
                  [disabled]="!promoCode || !promoCode.trim()"
                  (click)="applyPromoCode()">
            Apply
          </button>

        </div>

        <div *ngIf="promoMessage"
             class="promo-invalid-msg"
             [style.color]="promoMessageColor">
          {{ promoMessage }}
        </div>
      </div>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column [editable]="false" field="jobName" [minResizableWidth]="100" [width]="110" title="Quote Name"
                     [footerStyle]="{'border-color': 'rgba(0,0,0,0)'}">
  </kendo-grid-column>
  <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
    <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
    <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
    <kendo-pager-info></kendo-pager-info>
    <kendo-pager-next-buttons></kendo-pager-next-buttons>
    <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
  </ng-template>

  <kendo-grid-column media="(min-width: 1050px)" [editable]="false" field="jobName" [minResizableWidth]="100" [width]="110" title="Quote Name"
                     [footerStyle]="{'border-color': 'rgba(0,0,0,0)'}">
  </kendo-grid-column>
</kendo-grid>
